import { MetapropertiesOption, SearchMetaproperty } from '../types';

const byLabel = (a: MetapropertiesOption, b: MetapropertiesOption) =>
	a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });

// Options without a numeric zindex go last, keeping their relative order (the sort is stable).
const byZindex = (a: MetapropertiesOption, b: MetapropertiesOption) =>
	(a.zindex ?? Infinity) - (b.zindex ?? Infinity) || 0;

/** Returns the options in the order the metaproperty asks for — case-insensitive label unless `orderBy` is 'zindex'. Never mutates the response. */
export const sortMetapropertyOptions = (metaproperty: SearchMetaproperty): MetapropertiesOption[] =>
	(metaproperty.options ?? []).toSorted(metaproperty.orderBy === 'zindex' ? byZindex : byLabel);
